import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import '../css/loading.css';

class LoadingContent extends Component{
  constructor(props){
    super(props);
  }
  componentDidMount(){
    //console.log('loading');
  }
  render(){
    return (
      <>
        <div className="loading-content">
          <svg version="1.1" x="0px" y="0px"
            viewBox="-25 0 100 100" enableBackground="new 0 0 0 0">
            <circle fill="var(--loader-content)" stroke="none" cx="6" cy="50" r="6">
              <animate
                attributeName="opacity"
                dur="1s"
                values="0;1;0"
                repeatCount="indefinite"
                begin="0.1"/>    
            </circle>
            <circle fill="var(--loader-content)" stroke="none" cx="26" cy="50" r="6">
              <animate
                attributeName="opacity"
                dur="1s"
                values="0;1;0"
                repeatCount="indefinite" 
                begin="0.2"/>       
            </circle>
            <circle fill="var(--loader-content)" stroke="none" cx="46" cy="50" r="6">
              <animate
                attributeName="opacity"
                dur="1s"
                values="0;1;0"
                repeatCount="indefinite" 
                begin="0.3"/>     
            </circle>
          </svg>
        </div>
      </>
    );
  }
};

export default LoadingContent;